import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
const MODES = ['Pushing', 'Carrying', 'Avoiding', 'Waiting', 'Reacting', 'Holding'];
export function WorkMirrorModeLog() {
  const navigate = useNavigate();
  const [selectedModes, setSelectedModes] = useState<string[]>([]);
  const handleModeToggle = (mode: string) => {
    if (selectedModes.includes(mode)) {
      // Deselect
      setSelectedModes(selectedModes.filter(m => m !== mode));
    } else {
      // Select (max 2)
      if (selectedModes.length < 2) {
        setSelectedModes([...selectedModes, mode]);
      } else {
        // Replace the first selected with the new one
        setSelectedModes([selectedModes[1], mode]);
      }
    }
  };
  const handleSave = () => {
    if (selectedModes.length > 0) {
      // Save mode log
      console.log('Saving mode log:', selectedModes);
      // Navigate back to app home
      navigate('/work-mirror/app');
    }
  };
  const handleCancel = () => {
    navigate('/work-mirror/app');
  };
  return <>
      <Helmet data-id="element-4252">
        <title data-id="element-4253">Log Mode | Work Mirror</title>
        <meta name="robots" content="noindex, nofollow" data-id="element-4254" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-4255">
        {/* Top Bar */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A] border-b border-[#2B2B2B]" data-id="element-4256">
          <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-4257">
            <button onClick={handleCancel} className="text-sm text-gray-500 hover:text-gray-400 transition-colors" data-id="element-4258">
              Cancel
            </button>

            <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-4259">
              Log mode
            </p>

            <button onClick={handleSave} disabled={selectedModes.length === 0} className="text-sm text-[#F5F5F5] hover:text-gray-400 transition-colors disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:text-[#F5F5F5]" data-id="element-4260">
              Save
            </button>
          </div>
        </header>

        <main className="pt-24 pb-16 px-6" data-id="element-4261">
          <div className="max-w-2xl mx-auto space-y-12" data-id="element-4262">
            {/* Title & Subtext */}
            <div className="space-y-4 pt-8" data-id="element-4263">
              <h1 className="text-2xl md:text-3xl font-light text-[#F5F5F5] leading-relaxed" data-id="element-4264">
                What mode were you mostly in today?
              </h1>
              <p className="text-base text-gray-500" data-id="element-4265">
                Just pick what was most dominant.
              </p>
            </div>

            {/* Mode Options */}
            <div className="grid grid-cols-2 gap-4" data-id="element-4266">
              {MODES.map(mode => <button key={mode} onClick={() => handleModeToggle(mode)} className={`p-6 border transition-all text-lg font-light ${selectedModes.includes(mode) ? 'border-[#F5F5F5] bg-[#F5F5F5]/5 text-[#F5F5F5]' : 'border-[#2B2B2B] text-gray-400 hover:border-[#64748B]'}`} data-id="element-4267">
                  {mode}
                </button>)}
            </div>

            {/* Helper text */}
            {selectedModes.length > 0 && <div className="text-center" data-id="element-4268">
                <p className="text-xs text-gray-600" data-id="element-4269">
                  {selectedModes.length === 1 ? 'You can pick one more if needed.' : 'Max 2 modes selected.'}
                </p>
              </div>}
          </div>
        </main>
      </div>
    </>;
}